import type { IAgentTool } from '../IAgentTool';

export const clearRulesTool: IAgentTool = {
  name: 'clear_rules',
  description: 'Clear all filters and display rules.',
  parameters: {
    type: 'object',
    properties: {},
  },
  supportedDiagramTypes: [],
  tier: 'visual',
  category: 'display',

  async execute(_params, context) {
    context.stores.viewRules.clearFilter();
    const displayRules = context.stores.viewRules.getDisplayRules();
    displayRules.forEach((rule) => context.stores.viewRules.removeRule(rule.id));

    if (context.stores.highlight?.clearHighlights) {
      context.stores.highlight.clearHighlights();
    }

    return { success: true, summary: 'Cleared all filters and display rules.' };
  },
};
